/**
 * Application constants
 */

/** API base URL - relative path via CloudFront proxy */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/v1';

/** Cognito configuration */
export const COGNITO_CONFIG = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  // DEPRECATED (Spec 0043): Werden in Phase 1b entfernt (nach 2 Wochen stabilem Custom-Login-Betrieb)
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  redirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI || `${window.location.origin}/auth/callback`,
  logoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI || window.location.origin,
} as const;

/** Feature flags */
export const FEATURES = {
  themeEditor: import.meta.env.VITE_ENABLE_THEME_EDITOR === 'true',
} as const;

/**
 * MFA-Konfiguration (Spec 0045)
 * Rollen, fuer die MFA Pflicht ist. Konfigurierbar ueber Env-Variable.
 */
export const MFA_CONFIG = {
  requiredRoles: (import.meta.env.VITE_MFA_REQUIRED_ROLES || 'platform_admin,platform_it,platform_ops')
    .split(',')
    .map((r: string) => r.trim())
    .filter(Boolean),
} as const;

/** Application version */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.0.0';

/** Build date */
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || new Date().toISOString().split('T')[0];
